import React from 'react';
import { Layout } from '../../components/Layout';
import { Code2 } from 'lucide-react';

export function APIReferencePage() {
  return (
    <Layout fullWidth>
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <Code2 className="h-8 w-8 text-red-400" />
          <h1 className="text-3xl font-bold text-white">API Reference</h1>
        </div>

        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2>Authentication</h2>
              <p>
                Learn how to authenticate your API requests using API keys.
              </p>
              <div className="bg-gray-800/50 rounded-lg p-4 mt-4">
                <pre className="text-sm">
                  <code>
                    {`curl -X POST https://api.voltblocks.com/v1/generate \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{"prompt": "Create a hero section"}'`}
                  </code>
                </pre>
              </div>
            </section>

            <section>
              <h2>Endpoints</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold">Pattern Generation</h3>
                  <code className="text-sm bg-gray-800/50 px-2 py-1 rounded">POST /v1/generate</code>
                  <p className="mt-2">Generate a new block pattern from a text prompt.</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold">Pattern Management</h3>
                  <code className="text-sm bg-gray-800/50 px-2 py-1 rounded">GET /v1/patterns</code>
                  <p className="mt-2">Retrieve your saved patterns.</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold">Templates</h3>
                  <code className="text-sm bg-gray-800/50 px-2 py-1 rounded">GET /v1/templates</code>
                  <p className="mt-2">Access available templates.</p>
                </div>
              </div>
            </section>

            <section>
              <h2>Rate Limits</h2>
              <p>
                API rate limits vary by plan:
              </p>
              <ul>
                <li>Free: 100 requests/hour</li>
                <li>Pro: 1,000 requests/hour</li>
                <li>Enterprise: Custom limits</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}